import { render, staticRenderFns } from "./StudioMain.vue?vue&type=template&id=e42262de&scoped=true&"
import script from "./StudioMain.vue?vue&type=script&lang=js&"
export * from "./StudioMain.vue?vue&type=script&lang=js&"
import style0 from "./StudioMain.vue?vue&type=style&index=0&id=e42262de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42262de",
  null
  
)

component.options.__file = "StudioMain.vue"
export default component.exports